import React from 'react';

const SvgActions75 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M17 2h-1v14h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-5-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions75 svgRef={ref} {...props} />);
export default ForwardRef;
